class HeaderController {
    constructor($breakpoints) {
        this.$breakpoints = $breakpoints;
    }
}

const headerComponentDefinition = {
    controller: ['BreakpointsService', HeaderController],
    template: require('./header.component.html').trim(),
};

module.exports = {
    HeaderController,
    headerComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/header/header.component.js